export default getText => key =>
  ({
    reduce: getText('Reduce', 'Home_Tabs_Appointments_Header'),
    expand: getText('Expand', 'Home_Tabs_Appointments_Header'),
  }[key])
